import { observable, action } from 'mobx'
import ApiCaller from '../utils/api-caller'

class printFileStore {
    @observable menu = null;
    @observable remark = '';
    @observable fileUrls = '';
    @observable fileUrlList = '';
    @observable printCodeNotFound = false;
    @observable isReading = true;

    @action setRemark(value) { this.remark = value }
    @action setFileUrl(url) {
        if (this.fileUrls === '') {
            this.fileUrls = url + ';'
        } else {
            const anotherUrl = url + ';';
            this.fileUrls = this.fileUrls + anotherUrl;
        }
    }

    @action getData() {
        this.remark = '';
        this.fileUrls = '';

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getPrint(languageCode).then(resp => {
            return this.menu = resp;
        });
    }

    @action resetField() {
        this.remark = ''
        this.fileUrls = ''
    }

    @action getPrintFile(printCode) {
        this.isReading = true
        return ApiCaller.PrintFile.GetFilter(printCode).then((response) => {
            if (response) {
                this.printCodeNotFound = false
                this.remark = response.remark
                this.fileUrlList = response.fileUrls.split(';')
                this.isReading = false
            } else {
                this.printCodeNotFound = true
                this.isReading = false
            }
        })
    }
}

export default new printFileStore()